// Invitation Service - API calls for user registration flow
import axios from 'axios';
import config from '../config';

// Create axios instance without auth interceptors (public endpoints)
const publicApi = axios.create({
  baseURL: config.api.base_url,
  timeout: 30000,
});

/**
 * Verify invitation token
 * @param {string} token - The invitation token from email link
 * @returns {Promise<{success: boolean, data: object, message: string}>}
 */
export const verifyInvitation = async (token) => {
  try {
    const response = await publicApi.post('/auth/verify-invite', { token });
    return {
      success: response.data.status,
      data: response.data.data,
      message: response.data.message,
    };
  } catch (error) {
    return {
      success: false,
      data: error.response?.data?.data || null,
      message: error.response?.data?.message || 'Failed to verify invitation',
    };
  }
};

/**
 * Validate session token
 * @param {string} sessionToken - The session token from verify-invite response
 * @returns {Promise<{success: boolean, data: object, message: string}>}
 */
export const validateSession = async (sessionToken) => {
  try {
    const response = await publicApi.post('/auth/validate-session', { sessionToken });
    return {
      success: response.data.status,
      data: response.data.data,
      message: response.data.message,
    };
  } catch (error) {
    return {
      success: false,
      data: error.response?.data?.data || null,
      message: error.response?.data?.message || 'Session validation failed',
    };
  }
};

/**
 * Set password for new user
 * @param {string} sessionToken - The session token
 * @param {string} password - New password
 * @param {string} confirmPassword - Confirm password
 * @returns {Promise<{success: boolean, message: string}>}
 */
export const setPassword = async (sessionToken, password, confirmPassword) => {
  try {
    const response = await publicApi.post('/auth/set-password', {
      sessionToken,
      password,
      confirmPassword,
    });
    return {
      success: response.data.status,
      message: response.data.message,
    };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || 'Failed to set password',
    };
  }
};

export default {
  verifyInvitation,
  validateSession,
  setPassword,
};
